import {Component, OnDestroy, OnInit, ViewEncapsulation ,AfterViewInit } from '@angular/core';



import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommandResponse} from '@shared/commands/command-base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, take, takeUntil } from 'rxjs';
import { PlatformQuery } from '@shared/models/platform-query/platform-query';
import { Api } from '@shared/constants/common-field.constants';
import { CommandService } from '@core/services/command.service';
import { PlatformQueryService } from '@core/services/platform-query.service';
import { Router } from '@angular/router';
import { numeric, validateCbcRequiredDate, validateLocalExchangeRate } from '@shared/components/platform-tool/platform-tool-dialog-definition/models/validators-model';
import { SnackBarService } from '@core/services/snack-bar.service';

@Component({
    standalone: false,
    selector: 'lib-cbc-required-edit',
  templateUrl: './cbc-required-edit.component.html',
  styleUrls: ['./cbc-required-edit.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CbcRequiredEditComponent implements OnInit, OnDestroy , AfterViewInit, IPlatformToolComponent {

  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  invalidateSubject: InvalidateSubject;

  defaultDate = new Date(1970, 1, 2);

  fiscalYearMet: FormGroup;
  iscbCRulesEffectiveResidentEnabled = false;
  iscbCRulesEffectiveNonResidentEnabled = false;

  annualRevenueThresholdMetForm: FormGroup;
  annualThresholdApplicable = false;
  revenueInLocalCurrency: any;
  cbcReportRequired = "";
  cbcReportRequiredOverwrite = false;
  overwritterncbcReportRequire = "";
  fiscalYearStartDateString :any;

  cbcComplianceData: any;
  masterScenarioData: any;
  cbcReportFiling:any;
  jurisdictionCountry:any;
  currencies:any;

  isInitialized = false;

  private ngUnsubscribe = new Subject<void>();

  constructor(private formBuilder: FormBuilder,
    private platformQueryService: PlatformQueryService,
    private router: Router,
    private snackBarService: SnackBarService,
    private commandService: CommandService) {
    this.invalidateSubject = new InvalidateSubject();
  }
  onLoad() {

  }
  onBeforeExecuteNextCommand(): boolean {
    console.log('next command fired');
    if(this.selectedTab.id=='FiscalYearTestMet'){
      if(!this.fiscalYearMet.valid){
        this.snackBarService.showError('Inputs are not valid');
        return false;
      }
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['ResidentParentDate'] = this.getUTCDateWithoutTime(new Date(this.fiscalYearMet.value['cbcRequiredEffectiveForResident']));
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['ResidentParentDateApplicable'] = this.fiscalYearMet.value['cbcRequiredResidentCheckBox'];
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['NonResidentParentDate'] = this.getUTCDateWithoutTime(new Date(this.fiscalYearMet.value['cbcRequiredEffectiveForNonResident']));
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['NonResidentParentDateApplicable'] = this.fiscalYearMet.value['cbcRequiredNonResidentCheckBox'];
    }if(this.selectedTab.id=='AnnualRevenueThresholdMet'){
      if(!this.annualRevenueThresholdMetForm.valid){
        this.snackBarService.showError('Inputs are not valid');
        return false;
      }
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['ThresholdLogicApplicable'] = this.annualThresholdApplicable;
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['LocalCurrencyCode'] = this.annualRevenueThresholdMetForm.value['consolidatedRevenueLocalCurrency'];
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['LocalExchangeRate'] = this.annualRevenueThresholdMetForm.value['consolidatedRevenueLocalExchangeRate'];
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['IsLocalExchangeRateEdited'] = this.cbcReportFiling.isLocalExchangeRateEdited;
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['Threshold'] = this.annualRevenueThresholdMetForm.value['cbcRportingThresholdAmount'];
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['ThresholdCurrencyCode'] = this.annualRevenueThresholdMetForm.value['cbcRportingThresholdCurrency'];
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['IsCbcRequiredOverwritten'] = this.cbcReportRequiredOverwrite;
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['IsCbcRequired'] = this.cbcReportRequired == 'Yes' ? true : false;
      this.magicLinkModel.tabBar.nextButtonCommand.fieldValues['CbcReportRequiredUpdated'] = true;
    }
    return true;
  }
  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
    if(this.selectedTab.id=='AnnualRevenueThresholdMet'){
      this.router.navigateByUrl('/cbc/compliance');
    }
  }
  onBeforeExecutePreviousCommand(): boolean {
    if(this.selectedTab.id=='FiscalYearTestMet'){
      this.router.navigateByUrl('/cbc/compliance');
    }
    return true;
  }
  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {

  }

  ngOnInit() {
    console.log("dasdas");
    this.setInitialDatas();
  }
  setInitialDatas() {
    let complianceQuery = this.cbcComplianceNecessaryModelsQuery();
    this.platformQueryService.executeQuery(complianceQuery).pipe(take(1)).subscribe(res=>{
      if(res && res.fieldValues){
        this.cbcReportFiling = res.fieldValues['CbcReportFiling'];
        this.jurisdictionCountry = res.fieldValues['JurisdictionCountry'];
        this.masterScenarioData = res.fieldValues['MasterScenario'];
        if(this.magicLinkModel.fieldValues['IsCurrencyNeeded']){
          let currencyQuery = this.getAllCurrenciesQuery();
          this.platformQueryService.executeQuery(currencyQuery).pipe(take(1)).subscribe(res2 => {
            if(res2 && res2.fieldValues){
              this.setCurrency(res2.fieldValues['AllCurrencies']);
              this.intitialForms();
              this.isInitialized = true;
            }
          });
        } else {
          this.intitialForms();
          this.isInitialized = true;
        }
      }
    });
  }



  setCurrency(currentCurrencies): any {
    if(currentCurrencies){
      this.currencies = [];
      currentCurrencies.forEach(currency => {
        let currenctCurrency = {
          value: currency.currencyCode,
          text: currency.displayName
        }
        this.currencies.push(currenctCurrency);
      });
    }
  }

  intitialForms(){
    this.createFiscalYearMetForm();
    this.createAnualRevenueThresholdMetForm();
    this.annualRevenueThresholdMetFormChange();
  }



  createAnualRevenueThresholdMetForm() {
    this.cbcReportRequiredOverwrite = this.cbcReportFiling.isCbcRequiredOverwritten;
    this.cbcReportRequired = this.cbcReportFiling.isCbcRequired ? 'Yes' : 'No';
    this.annualThresholdApplicable = this.cbcReportFiling.thresholdLogicApplicable;
    this.revenueInLocalCurrency = this.cbcReportFiling.localExchangeRate * this.masterScenarioData.fieldValues.ConsolidatedGroupRevenue;
    this.annualRevenueThresholdMetForm = this.formBuilder.group({
      annualRevenueThresholdApplicable: [this.cbcReportFiling.thresholdLogicApplicable],
      consolidatedRevenuePreviousYearAmount: [this.masterScenarioData.fieldValues.ConsolidatedGroupRevenue],
      consolidatedRevenuePreviousYearCurrency: [this.masterScenarioData.ultimateParentEntityCurrency],
      consolidatedRevenueLocalAmount: [this.revenueInLocalCurrency],
      consolidatedRevenueLocalCurrency: [this.cbcReportFiling.localCurrencyCode],
      consolidatedRevenueLocalExchangeRate: [this.cbcReportFiling.localExchangeRate,[Validators.required,validateLocalExchangeRate,numeric]],
      cbcRportingThresholdAmount: [this.cbcReportFiling.threshold,[Validators.required,validateLocalExchangeRate,numeric]],
      cbcRportingThresholdCurrency: [this.cbcReportFiling.thresholdCurrencyCode],
    });
  }

  private createFiscalYearMetForm() {
    this.iscbCRulesEffectiveResidentEnabled = this.cbcReportFiling.residentParentDateApplicable;
    this.iscbCRulesEffectiveNonResidentEnabled = this.cbcReportFiling.nonResidentParentDateApplicable;
    this.fiscalYearStartDateString = this.getDisplayDateFormISO(this.masterScenarioData.taxYearStart);
    this.fiscalYearMet = this.formBuilder.group({
      jurisdiction: [this.jurisdictionCountry.name],
      ultimateParentFiscalYearStartDate: [this.fiscalYearStartDateString],
      cbcRequiredResidentCheckBox: [this.cbcReportFiling.residentParentDateApplicable],
      cbcRequiredEffectiveForResident: [this.cbcReportFiling.residentParentDate,[validateCbcRequiredDate]],
      cbcRequiredNonResidentCheckBox: [this.cbcReportFiling.nonResidentParentDateApplicable],
      cbcRequiredEffectiveForNonResident: [this.cbcReportFiling.nonResidentParentDate,[validateCbcRequiredDate]],
    });
  }

  annualRevenueThresholdMetFormChange(): void {
    this.annualRevenueThresholdMetForm.get('consolidatedRevenueLocalExchangeRate').valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(val => {
      console.log(val);
      this.cbcReportFiling.isLocalExchangeRateEdited = true;
      this.revenueInLocalCurrency = val * this.masterScenarioData.fieldValues.ConsolidatedGroupRevenue;
      this.annualRevenueThresholdMetForm.get('consolidatedRevenueLocalAmount').setValue(this.revenueInLocalCurrency);
    });

    this.annualRevenueThresholdMetForm.get('consolidatedRevenueLocalCurrency').valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(val => {
      console.log(val);
      let query = this.exchangeRateQuery(val);
      this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(res=>{
        let rate = res.fieldValues['ConvertedCurrencyRate'];
        this.cbcReportFiling.isLocalExchangeRateEdited = false;
        this.revenueInLocalCurrency = rate * this.masterScenarioData.fieldValues.ConsolidatedGroupRevenue;
        this.annualRevenueThresholdMetForm.get('consolidatedRevenueLocalAmount').setValue(this.revenueInLocalCurrency);
        this.annualRevenueThresholdMetForm.get('consolidatedRevenueLocalExchangeRate').setValue(rate);
      });
    });
  }




  ngAfterViewInit() {

  }


  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  updateCbcRequiredEffectiveForResident(){
    this.iscbCRulesEffectiveResidentEnabled = !this.iscbCRulesEffectiveResidentEnabled;
  }


  updateCbcRequiredEffectiveForNonResident(){
    this.iscbCRulesEffectiveNonResidentEnabled = !this.iscbCRulesEffectiveNonResidentEnabled;
  }


  updateAnnualRevenueThresholdApplicable(){
    this.annualThresholdApplicable = !this.annualThresholdApplicable;
  }

  private exchangeRateQuery(val: any) {
    let destinationCurrencyCode = val;
    let srcCurrencyCode = this.cbcReportFiling.localCurrencyCode;
    let exchangeDate = new Date();
    let query = new PlatformQuery();
    query.name = Api.DueDateTracker + 'GetExchangeRateQuery';
    query.api = Api.DueDateTracker;
    query.fieldValues['ExchangeDate'] = exchangeDate;
    query.fieldValues['SourceCurrencyCode'] = srcCurrencyCode;
    query.fieldValues['DestinationCurrencyCode'] = destinationCurrencyCode;
    return query;
  }

  private getAllCurrenciesQuery() {
    let query = new PlatformQuery();
    query.name = Api.DueDateTracker + "GetAllCurrenciesQuery";
    query.api = Api.DueDateTracker;
    query.projectId = '[PROJECT_ID]';
    return query;
  }
  private cbcComplianceNecessaryModelsQuery() {
    let query = new PlatformQuery();
    query.name = "CbcComplianceNecessaryModelsQuery";
    query.api = Api.DueDateTracker;
    query.projectId = '[PROJECT_ID]';
    query.fieldValues['CbcComplianceId'] = this.magicLinkModel.fieldValues['CbcComplianceItemId'];
    query.fieldValues['IncludeCbcReportFiling'] = true;
    query.fieldValues['IncludeJurisdictionCountry'] = true;
    query.fieldValues['IncludeMasterScenario'] = true;
    return query;
  }


  getDisplayDateFormISO(isoDateString){
    let date = new Date(isoDateString);
    let formattedDate = date.toLocaleString('en-US', { day: '2-digit', month: 'long', year: 'numeric' });
    return formattedDate;
  }

  getUTCDateWithoutTime(dateTime:Date):Date{
    return new Date(Date.UTC(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate()));
  }

}
